import { HtmlPurifier } from './html-purifier';
import { MarkdownParser } from './markdown';

export const useMarkdown = () => {
	const parse = (raw: string) => {
		const mdParser = new MarkdownParser([]);
		return mdParser.parse(raw);
	};

	const purify = HtmlPurifier.purify;

	return { purify, parse } as const;
};
